import React, { useState } from 'react';

const FoldableStatusList = ({ status }) => {
	const [okOpen, setOkOpen] = useState(false);
	const [errOpen, setErrOpen] = useState(true);

	if (!status) return null;

	const okItems = Object.entries(status)
		.filter(([k, v]) => k !== 'allGood' && v.ok && v.value)
		.map(([k, v]) => ({ key: k, value: v.value }));

	const errItems = Object.entries(status)
		.filter(([k, v]) => k !== 'allGood' && !v.ok && v.err)
		.map(([k, v]) => ({ key: k, err: v.err }));

	return (
		<div className="dashboard_site_info__foldable">
			{status.allGood && (
				<div className="dashboard_site_info__good-msg">
					Keine Probleme mit den Wordpress Konfigurationsdaten
				</div>
			)}

			{/* Errors */}
			{errItems.length > 0 && (
				<div className="dashboard_site_info__errors">
					<button
						type="button"
						className="dashboard_site_info__toggle"
						onClick={() => setErrOpen(!errOpen)}
					>
						{errOpen ? '▲' : '▼'}
						Fehlermeldungen
					</button>
					{errOpen && (
						<ul>
							{errItems.map(item => (
								<li key={item.key} className="dashboard_site_info__err">
									{item.err}
								</li>
							))}
						</ul>
					)}
				</div>
			)}

			{/* OK items */}
			{okItems.length > 0 && (
				<div className="dashboard_site_info__oks">
					<button
						type="button"
						className="dashboard_site_info__toggle"
						onClick={() => setOkOpen(!okOpen)}
					>
						{okOpen ? '▲' : '▼'}
						Konfigurationsdaten
					</button>
					{okOpen && (
						<ul>
							{okItems.map(item => (
								<li key={item.key} className="dashboard_site_info__ok">
									{item.value}
								</li>
							))}
						</ul>
					)}
				</div>
			)}
		</div>
	);
};

export default FoldableStatusList;
